import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout';
import { NgSelectModule } from '@ng-select/ng-select';
import { LfMessageToastModule } from '@lf-web-components/lf-message-toast';

import { DialogModule } from '@lf-web-components/lf-dialog-library';
import { CommonUtilsModule, LocalizePipe } from '@lf-web-components/lf-common-utils-library';
import { RepositoryService } from './services/resource/repository.service'

import { FilesetShellComponent } from './fileset-shell/fileset-shell.component';
import { OrganizerTableComponent } from './organizer-table/organizer-table.component';
import { OrganizerToolbarComponent } from './organizer-toolbar/organizer-toolbar.component';
import { FileBrowserDialogComponent } from './file-browser-dialog/file-browser-dialog.component';
import { ErrorMessagesComponent } from './error-messages/error-messages.component';
import { ImportLocalDialogComponent } from './import-local-dialog/import-local-dialog.component';
import { ImportPickerDialogComponent } from './import-picker-dialog/import-picker-dialog.component';
import { FilesetPrintComponent } from './fileset-print/fileset-print.component';
import { ValidatorService } from './services/validation/validator.service';
import { FilesetValidatorService } from './services/validation/fileset-validator.service';
import { LfRepositoryBrowserModule } from '@laserfiche/lf-ui-components/lf-repository-browser';


@NgModule({
  declarations: [
    FilesetShellComponent, 
    OrganizerTableComponent, 
    OrganizerToolbarComponent, 
    FileBrowserDialogComponent,
    ErrorMessagesComponent,
    ImportLocalDialogComponent,
    ImportPickerDialogComponent,
    FilesetPrintComponent
    ],
  imports: [
    HttpClientModule,
    FormsModule,
    CommonModule, 
    CommonUtilsModule,
    CdkTableModule, 
    DragDropModule,
    OverlayModule,
    MatIconModule,
    FlexModule,
    NgSelectModule,
    DialogModule,
    NgSelectModule,
    LfMessageToastModule,
    LfRepositoryBrowserModule
  ],
  providers: [
    RepositoryService,
    LocalizePipe,
    ValidatorService,
    FilesetValidatorService
  ],
  exports: [FilesetShellComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FilesetRuntimeModule { }
